import React from 'react';
import type { FormInstance } from 'antd';
import { Form } from 'antd';
import BoldOutlined from '@ant-design/icons/BoldOutlined';
import ItalicOutlined from '@ant-design/icons/ItalicOutlined';
import UnderlineOutlined from '@ant-design/icons/UnderlineOutlined';
import { FormToggleIconButton } from './FormToggleIconButton';
import { styleFieldName } from '../../utils/styleFormFieldNames';
import { applyDedicatedTypographyToForm } from './fontFamilyFormSync';

type Props = {
  form: FormInstance;
  namePrefix?: string | string[];
};

const BoldToggle: React.FC<{
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  form: FormInstance;
  namePrefix?: string | string[];
}> = ({ checked, onChange, form, namePrefix }) => (
  <FormToggleIconButton
    title="Bold"
    effect="bold"
    checked={checked}
    onChange={(next) => {
      onChange?.(next);
      if (applyDedicatedTypographyToForm(form, namePrefix)) return;
      form.setFieldValue(styleFieldName(namePrefix, 'fontWeight'), next ? 700 : 400);
    }}
  >
    <BoldOutlined />
  </FormToggleIconButton>
);

const ItalicToggle: React.FC<{
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  form: FormInstance;
  namePrefix?: string | string[];
}> = ({ checked, onChange, form, namePrefix }) => (
  <FormToggleIconButton
    title="Italic"
    effect="italic"
    className="italic-btn"
    checked={checked}
    onChange={(next) => {
      onChange?.(next);
      applyDedicatedTypographyToForm(form, namePrefix);
    }}
  >
    <ItalicOutlined />
  </FormToggleIconButton>
);

export const StyleToggleButtons: React.FC<Props> = ({ form, namePrefix }) => (
  <div className="word-ribbon-inline">
    <Form.Item
      name={styleFieldName(namePrefix, 'bold')}
      valuePropName="checked"
      initialValue={false}
      noStyle
    >
      <BoldToggle form={form} namePrefix={namePrefix} />
    </Form.Item>
    <Form.Item
      name={styleFieldName(namePrefix, 'italic')}
      valuePropName="checked"
      initialValue={false}
      noStyle
    >
      <ItalicToggle form={form} namePrefix={namePrefix} />
    </Form.Item>
    <Form.Item
      name={styleFieldName(namePrefix, 'underline')}
      valuePropName="checked"
      initialValue={false}
      noStyle
    >
      <FormToggleIconButton title="Underline" effect="underline">
        <UnderlineOutlined />
      </FormToggleIconButton>
    </Form.Item>
  </div>
);
